import React, {PropTypes} from 'react'
import RaisedButton from 'material-ui/RaisedButton'
import TextField from 'material-ui/TextField'

const styles = {
  submitButton: {
    marginTop: '1em'
  }
}

const LoginForm = (props) => {
  let usernameField = null
  let passwordField = null
  return (
    <form onSubmit={e => {
      e.preventDefault()
      let input = {
        username: usernameField.input.value,
        password: passwordField.input.value
      }
      props.onSubmit(input)
    }}>
      <TextField floatingLabelText="Usuário" ref={input => usernameField = input} fullWidth={true}/>
      <TextField floatingLabelText="Senha" ref={input => passwordField = input} type="password" fullWidth={true}/>
      <RaisedButton primary={true} label={props.isLoading ? 'Entrando...' : 'Entrar'} type="submit" disabled={props.isLoading} style={styles.submitButton} fullWidth={true}/>
    </form>
  )
}

LoginForm.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired
}

export default LoginForm



/** WEBPACK FOOTER **
 ** ./src/components/login/LoginForm.js
 **/